<template>
	<div class="wind-search">
		<form class="wind-search__content" action="" @submit.prevent="onSearch">
			<Icon class="search-icon" type="search"></Icon>
			<input
				v-model="currentValue"
				type="search"
				class="search-input"
				ref="searchInput"
				:placeholder="placeholder"
				:disabled="disabled"
			>
			<Icon
				v-show="value !== ''"
				class="search-clear-icon"
				type="search-clear"
				@click="onSearchClearClick"
			></Icon>
		</form>
		<Icon
			v-show='showFilterBtn'
			class="wind-search__btn"
			:imgUrl="iconSearchFilter"
			@click="onFilterBtnClick"
		></Icon>
		<div class="wind-search__right">
			<slot v-show="!showFilterBtn" name="search-right"></slot>
		</div>
	</div>
</template>

<script type="text/babel">
import Icon from '../icon'
export default {
	name: 'w-search',
	components: {
		Icon
	},
	props: {
		value: String,
		placeholder: String,
		showFilterBtn: {
			type: Boolean,
			default: true
		},
		borderRadius: {
			type: String,
			default: '20px'
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			searchDebounce: this.$fxUtils.debounce(),
			iconSearchFilter: require('../../../../assets/images/icon/wind-ui/icon-search-filter.png'),
			currentValue: ''
		}
	},
	watch: {
		value: {
			immediate: true,
			handler (val) {
				this.currentValue = val
			}
		},
		currentValue (val) {
			this.$emit('input', val)
		}
	},
	methods: {
		onFilterBtnClick () {
			this.$emit('on-filter-btn-click')
		},
		onSearchClearClick () {
			this.$emit('input', '')
			this.$emit('on-serch', '')
		},
		onSearch () {
			this.$refs.searchInput.blur()
			this.searchDebounce(500).then(() => {
				this.$emit('input', this.currentValue)
				this.$emit('on-serch', this.currentValue)
			})
		}
	}
}
</script>
<style scoped>
input::-webkit-search-decoration, input::-webkit-search-cancel-button {
	display: none;
}
.wind-search {
	display: flex;
	flex-direction: row;
	width: 100%;
	height: 40px;
	padding: 5px 0;
	box-sizing: border-box;
	background-color: #fff;
}
.wind-search__content {
	flex: 1;
	display: flex;
	flex-direction: row;
	margin: 0 10px;
	padding: 0px 10px;
	align-items: center;
	background-color: #eee;
	border-radius: 4px;
}
.search-icon, .search-clear-icon {
	width: 18px;
	height: 18px
}
.search-input {
	flex: 1;
	font-size: 12px;
	margin: 0;
	border: 0;
	width: 100%;
	padding: .7em;
	outline: none;
	border-radius: 2px;
	background: none;
	box-sizing: border-box;
}
.wind-search__btn {
	width: 50px;
	background-size: 20px
}
.wind-search__right {
	display: flex;
	margin: 5px;
	font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// Search.vue?4fff7600